import classNames from 'classnames';
import { ForwardedRef, forwardRef } from 'react';

import { InvisibleAnchor } from '~components/InvisibleAnchor';

import styles from './Section.module.scss';
import { SectionProps } from './Section.types';

export const Section = forwardRef(function Section(
  { className, children, mods, hash }: SectionProps,
  ref: ForwardedRef<HTMLDivElement>,
) {
  return (
    <section
      className={classNames(
        styles.section,
        className,
        mods?.map((mod) => styles[mod]),
      )}
      ref={ref}
    >
      {hash && <InvisibleAnchor id={hash} />}
      {children}
    </section>
  );
});
